var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editor)?_c('div',[_c('p',[_vm._v("Text align Option")]),_c('button',{class:{ 'is-active': _vm.editor.isActive({ textAlign: 'left' }) },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .setTextAlign('left')
        .run()}}},[_vm._v(" left ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive({ textAlign: 'center' }) },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .setTextAlign('center')
        .run()}}},[_vm._v(" center ")]),_c('button',{class:{ 'is-active': _vm.editor.isActive({ textAlign: 'right' }) },on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .setTextAlign('right')
        .run()}}},[_vm._v(" right ")]),_c('button',{on:{"click":function($event){_vm.editor
        .chain()
        .focus()
        .unsetTextAlign()
        .run()}}},[_vm._v(" unset align ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }